"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Always import {h} from preact
var preact_1 = require("preact");
var UroVpIngredients_1 = require("../components/Ingredients/UroVpIngredients");
var targetNode = document.querySelector('.uro-vp-ingredients-section');
if (targetNode) {
    (0, preact_1.render)((0, preact_1.h)(UroVpIngredients_1.default, null), targetNode);
}
